import toast from "react-hot-toast";
import { normalizeValidationErrors } from "./normalizers";

export function showCustomErrorToast({
    title,
    message,
    opts,
} : {
    title?: string | null;
    message: string | null;
    opts?: { duration?: number };
}) {
    const {
        duration,
    } = opts || {};

    toast.error(
        <div>
            {title !== undefined && (
                <h6 className="text-capitalize">
                    {title}
                </h6>
            )}
            <div>
                {message}
            </div>
        </div>,
        {
            duration
        }
    );
};

export function showErrorToast({
    message,
    status,
    opts
} : {
    message: string | null;
    status?: number;
    opts?: { duration?: number };
}) {
    const {
        duration = 5000,
    } = opts || {};

    if (status) {
        toast.error(
            <div>
                {status && (
                    <h6>
                        Error_Code: {status}
                    </h6>
                )}
                <div>
                    {message}
                </div>
            </div>, {
                ...opts,
                duration
            }
        );
    }
    else {
        toast.error(message, {
            ...opts,
            duration
        });
    }
};

export function showServerErrorToast ({
    err_message,
    err_status,
    list_errors,
    opts = {}
} : {
    err_message: string | null;
    err_status: number | undefined;
    list_errors: ApiErrorMessage | undefined;
    opts?: { duration?: number; errorTitle?: string | null; };
}) {
    const {
        duration = 7000,
    } = opts;

    // 🔹 Validation errors (422)
    if (list_errors && typeof list_errors === "object") {
        const normalized = normalizeValidationErrors(list_errors);

        toast.error(
            <div>
                <h4 className="mb-2">{opts?.errorTitle}</h4>
                <ul className="mb-0 ps-3">
                    {normalized.map((err, index) => (
                        <li key={index} style={{fontSize:'14px', fontWeight:'bold'}}>
                            {err.message}
                        </li>
                    ))}
                </ul>
            </div>,
            { duration }
        );

        return;
    }

    // 🔹 Normal error
    if (err_status) {
        toast.error(
            <div>
                <h6>{err_status}</h6>
                <div>{err_message}</div>
            </div>,
            { duration }
        );
    } else {
        toast.error(err_message || "Something went wrong", { duration });
    }
};
